{
  "assetContainerEvent": {
    "types": {
      "arrived": "Em Pátio",
      "arrivedWaiting": "Em Pátio/Aguardando",
      "loading": "Carregando",
      "loadingComplete": "Carregamento Completo",
      "unloading": "Descarregando",
      "unloadingComplete": "Descarregamento Completo",
      "readyForPickup": "Pronto para Retirada",
      "departed": "Saiu do Pátio",
      "inoperable": "Inoperável",
      "missing": "Ausente",
      "inTransit": "Em trânsito"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "Chegado",
    "Docked": "Na Doca",
    "Parked": "Estacionado",
    "Unassigned": "Não Atribuído",
    "Dropped": "Desengatado",
    "Hooked": "Engatado",
    "Appointment Linked": "Agendamento Vinculado",
    "Appointment Unlinked": "Agendamento Desvinculado",
    "Status Updated": "Status Atualizado"
  },
  "assetContainerTypes": {
    "trailer": "Carreta",
    "container": "Contêiner",
    "oversized": "Superdimensionado",
    "chassis": "Chassi",
    "reefer": "Refrigerado",
    "other": "Outro"
  },
  "assetVisitTypes": {
    "live": "Ao Vivo",
    "drop": "Entrega",
    "pickup": "Engate",
    "dropHook": "Entrega e Engate"
  },
  "assetVisitDirections": {
    "inbound": "Entrada",
    "outbound": "Saída",
    "inboundAndOutbound": "Entrada e Saída"
  },
  "loadTypeDirections": {
    "inbound": "Entrada",
    "outbound": "Saída",
    "inOut": "Entrada e saída",
    "load": "Carregamento",
    "unload": "Descarregamento",
    "dropOff": "Entrega",
    "pickUp": "Retirada",
    "dropAndHook": "Entrega e engate",
    "inboundAndOutbound": "Entrada e saída"
  },
  "loadTypeOperations": {
    "live": "Ao vivo",
    "drop": "Entrega",
    "other": "Outro"
  },
  "loadTypeTypes": {
    "standard": "Padrão",
    "preparation": "Preparação"
  },
  "altAssetVisitTypes": {
    "unknown": "Desconhecido"
  },
  "assetContainerStates": {
    "full": "Cheio",
    "empty": "Vazio",
    "partiallyLoaded": "Parcialmente Carregado"
  },
  "spotStatuses": {
    "open": "aberto",
    "closed": "fechado",
    "assigned": "atribuído",
    "inTransit": "em trânsito",
    "reservedManual": "reservado",
    "reservedAutomated": "reservado",
    "unknown": "desconhecido"
  },
  "spotTypes": {
    "parking": "estacionamento",
    "docking": "doca de carga"
  },
  "labels": {
    "licensePlate": "Placa",
    "dotNumber": "Número DOT"
  },
  "messages": {
    "unknownCompany": "Empresa desconhecida",
    "unhooked": "Desengatado",
    "noInformationAvailable": "Nenhuma informação disponível",
    "noVisitFound": "Nenhuma visita encontrada",
    "notInformed": "Não informado",
    "waitingAssignment": "Aguardando atribuição",
    "failedToLoadSpotDetails": "Falha ao carregar os detalhes da vaga",
    "retry": "Tentar novamente",
    "blockedUntilSpotIsOpen": "Bloqueado até que {spot} esteja livre",
    "blockReasons": {
      "reservedByOther": "A vaga de destino está **reservada** para a **Tarefa de movimentação #{taskNumber}**.",
      "reservedByOtherGeneric": "A vaga de destino está **reservada**.",
      "destinationClosed": "A vaga de destino está **fechada**.",
      "destinationOccupied": "A vaga de destino está **ocupada** por outro ativo.",
      "anotherAssetInTransitForDestination": "**{assetCode}** já está em trânsito para esta vaga.",
      "assetInTransitElsewhere": "O ativo já está sendo movido por outra tarefa de movimentação."
    }
  }
}
